import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import { configureMenuItems } from '../routeGuard'
import ToastService from '@/services/toasterService'
import { allRoutes } from '@/common/RouteNameHelper'

/**
 * Base Mixins for all project
 */
export default {
  data () {
    return {
      /**
       * default tooltip options
       */
      tooltipOptions: {
        delay: { show: 100, hide: 300 },
        classes: 'rfx-tooltip'
      },
      leftMenuItems: []
    }
  },
  created () {
    if (this.currentUser) {
      this.leftMenuItems = configureMenuItems(allRoutes)
    }
  },
  watch: {
    currentUser: {
      handler (newCurrentUser) {
        if (newCurrentUser) {
          this.leftMenuItems = configureMenuItems(allRoutes)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['currentUser', 'selectedClient', 'clients', 'isNavbarCollapsed', 'adminRoutes', 'userRoles']),
    ...mapState('rankZoneCommon', ['difficultyScoreEnabled']),
    isCurrentUserClientCollaborator () {
      return this.currentUser && this.currentUser.isClientCollaborator() && !this.isCurrentUserAgent
    },
    isCurrentUserClientContributor () {
      return this.currentUser && this.currentUser.isClientContributor() && !this.isCurrentUserAgent
    },
    isClientDifficultyScoreEnabled () {
      return this.difficultyScoreEnabled
    },
    isCurrentUserAgent () {
      return this.currentUser &&
        (
          this.userRoles.includes('agency_user') ||
          this.userRoles.includes('agency_admin') ||
          this.userRoles.includes('admin')
        )
    },
    clientId () {
      return this.selectedClient ? this.selectedClient._id : null
    },
    clientName () {
      return this.selectedClient ? this.selectedClient.name : null
    },
    /**
     * helps calculate with of area does not covered by navbar
     */
    navBarWidth () {
      return this.isNavbarCollapsed ? 90 : 250
    },
    menuItems () {
      return this.leftMenuItems
    }
  },
  methods: {
    ...mapActions([
      'setSelectedClient'
    ]),
    /**
     *  date helper for safary
     */
    convertDateForSafary (date) {
      if (!date) {
        return null
      }
      if (typeof date === 'string') {
        return new Date(date.replace(/ /g, 'T'))
      }
      return date
    },
    /**
     * adds clear button to date picker popups
     */
    addClearButton () {
      const containerArray = document.getElementsByClassName('vc-container')
      const container = containerArray.length > 0 ? containerArray[0] : null
      if (!container) {
        return
      }
      Array.from(containerArray).forEach(container => {
        const isButtonAttached = container.querySelector('.rfx-clear-date-button')
        if (isButtonAttached) {
          return
        }
        if (container.parentElement.id === 'range') {
          return
        }
        container.style.height = '250px'
        const button = document.createElement('button')
        button.innerHTML = 'Clear'
        button.classList = 'rfx-clear-date-button'
        button.addEventListener('click', this.clearDateListener)
        container.appendChild(button)
      })
    },
    /**
     * removes clear button from date picker popups
     */
    removeClearButton () {
      const containerArray = document.getElementsByClassName('vc-container')
      const container = containerArray.length > 0 ? containerArray[0] : null
      if (!container) {
        return
      }
      Array.from(containerArray).forEach(container => {
        const button = container.querySelector('.rfx-clear-date-button')
        if (!button) {
          return
        }
        container.removeChild(button)
      })
    },
    setNewClient (clientId, updateRoles = false, changedFromNavbar = false) {
      const client = this.clients.find(item => item._id === clientId)
      if (!client) {
        ToastService.showToast(ToastService.ERROR_TYPE, 'You do not have access to this project')
        return false
      }
      // we assign the variable changedFromNavbar to handle only navbar change client events in content brief component
      this.setSelectedClient({ selectedClient: client, updateRoles, changedFromNavbar })
      return true
    }
  }
}
